var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.1,96.9l8.5,8.5L39,81.9c5.5,3.9,12.3,6.2,19.6,6.2c18.9,0,34.3-15.4,34.3-34.3S77.5,19.5,58.5,19.6 c-18.9,0-34.3,15.4-34.3,34.3c0,7.3,2.3,14,6.2,19.6L7.1,96.9z M34.3,53.8c0-13.4,10.9-24.3,24.3-24.3s24.3,10.9,24.3,24.3 S72,78.1,58.6,78.1S34.3,67.2,34.3,53.8z"}));
}

IconSearch.defaultProps = {"version":"1.1","x":"0px","y":"0px","xmlSpace":"preserve","fill":"#fff","width":"30","height":"31","viewBox":"3 11 95 95","preserveAspectRatio":"xMinYMin slice"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
